import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import {
    homeNode,
    IsNodeAlreadyComplete,
    todayNodeName,
    workflowRepository,
} from "motw_core/Repositories/WorkflowRepository";
import * as React from "react";
import { ExecuteNodeCompletion } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/ChildNodeName/CompleteNode/Helpers/ExecuteNodeCompletion";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";

export function CompleteNode({
    node,
    parentNode,
}: {
    node: IWorkflowNode;
    parentNode: IWorkflowNode;
}) {
    if (
        parentNode === undefined ||
        parentNode.name !== todayNodeName ||
        IsNodeAlreadyComplete(node.name)
    ) {
        return null;
    }

    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    return (
        <Render
            id="CompleteNode"
            when={node.id !== 0}
            withClasses={StyleClass(`CompleteNodeContainer`, {
                fontSize: "15px",
                position: "relative",
                bottom: "2px",
                color: "hsla(0, 0%, 0%, 0.77)",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                marginLeft: `10px`,
            })}
        >
            <Render id="completenode_unsaved" when={!isSaving}>
                <span
                    style={{
                        background: "yellowgreen",
                        borderRadius: "5px",
                        padding: "5px",
                    }}
                >
                    <IconWithText
                        iconSuffix={EGlyphicon.ok}
                        whenClicked={async () => {
                            setIsSaving(true);
                            await ExecuteNodeCompletion(node);
                            setIsSaving(false);
                        }}
                        displayAsBlock={false}
                    >
                        Done
                    </IconWithText>
                </span>
            </Render>
            <Render id="completenode_saving" when={isSaving}>
                <span
                    style={{
                        borderRadius: "5px",
                        padding: "5px",
                    }}
                >
                    <IconWithText
                        iconSuffix={EGlyphicon["download-alt"]}
                        whenClicked={async () => {}}
                        displayAsBlock={false}
                    >
                        saving...
                    </IconWithText>
                </span>
            </Render>
        </Render>
    );
}
